import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "chat",
    name: "chat",
    component: () => import("./pages/StaffChatPage.vue"),
    meta: { title: "menu.chat", requiresAuth: true, requiresStaff: true },
  },
  {
    path: "family/chat",
    name: "family-chat",
    component: () => import("./pages/FamilyChatPage.vue"),
    meta: { title: "menu.family_chat", requiresAuth: true },
  },
];
